import React from 'react';
import { Button } from '@/components/ui/button';
import { Type } from 'lucide-react';

/**
 * "Text" category — adds a new editable text box to the active page.
 * Styling (size/color/bold/align) happens in the contextual Properties
 * panel once the text element is selected, same convention as every
 * other element type.
 */
export function DesignTextPanel({ onAddText, disabled }) {
  if (disabled) {
    return <p className="text-sm text-[#8A93A6] text-center py-6" data-testid="design-text-panel-empty">Create or select a design first.</p>;
  }
  return (
    <div className="space-y-3" data-testid="design-text-panel">
      <Button size="sm" className="w-full bg-[#3A7BFF] hover:bg-[#3A7BFF]/90" onClick={() => onAddText('title')} data-testid="design-add-title-button">
        <Type className="h-4 w-4 mr-2" />Add Title
      </Button>
      <Button size="sm" variant="outline" className="w-full border-white/10" onClick={() => onAddText('body')} data-testid="design-add-body-text-button">
        <Type className="h-4 w-4 mr-2" />Add Body Text
      </Button>
      <p className="text-[11px] text-[#555E6E]">Select any text box on the canvas to change its size, color, weight or alignment.</p>
    </div>
  );
}
